import { render, staticRenderFns } from "./expire-notice.vue?vue&type=template&id=1387bfdc&scoped=true&"
import script from "./expire-notice.vue?vue&type=script&lang=js&"
export * from "./expire-notice.vue?vue&type=script&lang=js&"
import style0 from "./expire-notice.vue?vue&type=style&index=0&id=1387bfdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387bfdc",
  null
  
)

export default component.exports